module.exports = __webpack_public_path__ + "static/img/rocket-pro.e98d18bc.svg";